import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { PageTitle, PageContent, Button } from 'nallian-shared-ui/lib/components';
import HasRight from 'nallian-shared-ui/lib/layout/rights/HasRight';
import { connect } from 'react-redux';
import { history } from 'nallian-shared-ui/lib/config/history';
import { getFilters, reduxFilters } from 'nallian-shared-ui/lib/hoc/redux-filters';
import { getSorting } from 'nallian-shared-ui/lib/hoc/redux-sorting';
import reduxSorting from 'nallian-shared-ui/lib/hoc/redux-sorting/reduxSorting';
import { withTranslation } from 'react-i18next';
import VehicleSidebar from '../../vehicleSidebar/components/VehicleSidebar';
import OnPremiseNewAccessRightModal from './OnPremiseNewAccessRightModal';
import deleteAccessRightService from '../../accessRights/services/deleteAccessRightService';
import EditAccessRightModal from '../../accessRights/components/EditAccessRightModal';
import AccessRightsOverviewTable from '../../accessRights/components/AccessRightsOverviewTable';

const CREATE_ACCESS_RIGHT_RIGHT = 'access-rights/create';
const UPDATE_ACCESS_RIGHT_RIGHT = 'access-rights/update';

export const ON_PREMISE_ACTIONS = {
  NEW: 'new',
  EDIT: 'edit',
  VEHICLE_DETAILS: 'details',
};

class RequestsOverview extends PureComponent {
  state = {
    accessRightsLoading: [],
  };

  componentDidMount() {
    if (this.props.dispatchOnPremiseAccessRightsGet) {
      this.props.dispatchOnPremiseAccessRightsGet(this.props.filters, this.props.sorting);
    }
  }
  handleDeleteAccessRight = accessRightId => {
    this.setState(prevState => ({
      accessRightsLoading: [...prevState.accessRightsLoading, accessRightId],
    }));
    this.props.dispatchDeleteAccessRightDelete(accessRightId, () =>
      this.setState(prevState => ({
        accessRightsLoading: prevState.accessRightsLoading.filter(
          loadingId => accessRightId !== loadingId
        ),
      }))
    );
  };
  render() {
    const {
      match,
      t,
    } = this.props;
    const { action, actionId, subAction, subActionId } = match.params;
    return (
      <Fragment>
        <HasRight right={CREATE_ACCESS_RIGHT_RIGHT}>
          <OnPremiseNewAccessRightModal
            open={!!action && action === ON_PREMISE_ACTIONS.NEW}
            returnRoute="/accessrights"
          />
        </HasRight>
        <HasRight right={UPDATE_ACCESS_RIGHT_RIGHT}>
          <EditAccessRightModal
            accessRightId={((action && action === ON_PREMISE_ACTIONS.EDIT) || undefined) && actionId}
          />
        </HasRight>
        <VehicleSidebar
          vehicleId={
            ((action && action === ON_PREMISE_ACTIONS.VEHICLE_DETAILS) || undefined) && actionId
          }
          baseUrl="/accessrights"
          noAccessRightEdit
          sidebarAction={subAction}
          sidebarActionId={subActionId}
          sidebarUrl={`/accessrights/${ON_PREMISE_ACTIONS.VEHICLE_DETAILS}/${actionId}`}
        />

        <PageTitle>{t('accessRights_plural')}</PageTitle>
        <PageContent>
          <HasRight right={CREATE_ACCESS_RIGHT_RIGHT}>
            <Button
              onClick={() =>
                history.push(`/accessrights/${ON_PREMISE_ACTIONS.NEW}`, {
                  goBack: true,
                })
              }
              content={t('addAccessRight')}
              icon="add"
              primary
            />
          </HasRight>
          <AccessRightsOverviewTable isPrivate baseUrl="/accessrights" />
        </PageContent>
      </Fragment>
    );
  }
}
RequestsOverview.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  filters: PropTypes.object,
  sorting: PropTypes.object,
};

RequestsOverview.defaultProps = {
  filters: undefined,
  sorting: undefined,
};

const mapStateToProps = state => ({
  filters: getFilters(state, 'AccessRightsOverviewFilters'),
  sorting: getSorting(state, 'AccessRightsOverviewSorting'),
});

export default compose(
  withTranslation(),
  deleteAccessRightService,
  connect(mapStateToProps),
  reduxFilters({
    name: 'AccessRightsOverviewFilters',
    onChange: (filters, props) => props.dispatchOnPremiseAccessRightsGet(filters, props.sorting),
    debounced: ['licensePlate'],
  }),
  reduxSorting({
    name: 'AccessRightsOverviewSorting',
    onChange: (sorting, props) => props.dispatchOnPremiseAccessRightsGet(props.filters, sorting),
  })
)(RequestsOverview);
